/** Issuer IDs returned by Token API. */
export enum Issuers {
  BINANCE = 'binance',
  BSTOCKS = 'bstocks',
  CENTRIFUGE = 'centrifuge',
  CIRCLE = 'circle',
  COINBASE = 'coinbase',
  KRAKEN = 'kraken',
  PRESTOCKS = 'prestocks',
  ST0X = 'st0x',
  SUPERSTATE = 'superstate',
  TETHER = 'tether',
  XSTOCKS = 'xstocks',
  ROBINHOOD = 'robinhood',
  ONDO = 'ondo',
  ZORA = 'zora',
  MAPLE = 'maple',
}

export type IssuerDefinition = {
  /** Display name of the issuer. */
  name: string;
  /** Path to the issuer logo. */
  logo: string;
  /** Optional price provider override, uses the default provider when omitted. */
  priceSource?: 'coingecko';
  /** Hide the issuer badge. */
  hideBadge?: boolean;
};

export const issuerDefinitions: Record<Issuers, IssuerDefinition> = {
  [Issuers.BINANCE]: { name: 'Binance', logo: '/images/issuers/binance.webp' },
  [Issuers.BSTOCKS]: { name: 'bStocks', logo: '/images/issuers/bstocks.webp' },
  [Issuers.CENTRIFUGE]: { name: 'Centrifuge', logo: '/images/issuers/centrifuge.webp' },
  [Issuers.CIRCLE]: { name: 'Circle', logo: '/images/issuers/circle.webp' },
  [Issuers.COINBASE]: { name: 'Coinbase', logo: '/images/issuers/coinbase.webp' },
  [Issuers.KRAKEN]: { name: 'Kraken', logo: '/images/issuers/kraken.webp' },
  [Issuers.PRESTOCKS]: { name: 'PreStocks', logo: '/images/issuers/prestocks.webp' },
  [Issuers.ST0X]: { name: 'st0x', logo: '/images/issuers/st0x.webp' },
  [Issuers.SUPERSTATE]: { name: 'Superstate', logo: '/images/issuers/superstate.webp' },
  [Issuers.TETHER]: { name: 'Tether', logo: '/images/issuers/tether.webp' },
  [Issuers.XSTOCKS]: {
    name: 'xStocks',
    logo: '/images/issuers/xstocks.webp',
    priceSource: 'coingecko',
  },
  [Issuers.ROBINHOOD]: { name: 'Robinhood', logo: '/images/issuers/robinhood.webp' },
  [Issuers.ONDO]: { name: 'Ondo', logo: '/images/issuers/ondo.webp' },
  [Issuers.ZORA]: { name: 'Zora', logo: '/images/issuers/zora.webp', hideBadge: true },
  [Issuers.MAPLE]: { name: 'Maple', logo: '/images/issuers/maple.webp' },
};

export const isIssuerSupported = (id?: string | null): id is Issuers =>
  id != null && (Object.values(Issuers) as string[]).includes(id);
